import { cn } from "@/lib/utils"

export function Loading({ label = "Lädt..." }: { label?: string }) {
  return <div className="p-10 text-muted-foreground text-sm">{label}</div>
}

export function ErrorBox({ error, className }: { error: unknown; className?: string }) {
  const msg = error instanceof Error ? error.message : String(error)
  return (
    <div className={cn("p-6 rounded-md bg-destructive/10 text-destructive text-sm", className)}>
      Fehler: {msg}
    </div>
  )
}

/** Hilfs-Helper: "vor 5 min", "heute 14:32", "DD.MM. HH:MM" */
export function fmtRelative(iso: string | null | undefined): string {
  if (!iso) return ""
  try {
    const d = new Date(iso)
    const now = new Date()
    const diff = (now.getTime() - d.getTime()) / 1000
    if (diff < 60) return "gerade eben"
    if (diff < 3600) return `vor ${Math.round(diff / 60)} min`
    if (diff < 86400) return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })
    // altes Portal: "31.03. 08:32" (Datum ohne Jahr + Uhrzeit)
    const day = String(d.getDate()).padStart(2, "0")
    const month = String(d.getMonth() + 1).padStart(2, "0")
    const time = d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })
    return `${day}.${month}. ${time}`
  } catch { return iso.slice(0, 16) }
}
